module.exports = __webpack_public_path__ + "assets/images/project/map-logo-svg/tablet.svg?v=6514bf5a";